import { IPartnerAppSettings } from '../interface/IPartnerAppSettings';

export const sit: IPartnerAppSettings = {
  cdnBaseUrl: 'https://stcspsit.z22.web.core.windows.net/portfolio-ui',
  serviceEndPoints: [
  ],
  PortfolioAppConfiguration: {
  }
};
